import { render, staticRenderFns } from "./ModifierGroupList.vue?vue&type=template&id=06e6129b"
import script from "./ModifierGroupList.vue?vue&type=script&lang=js"
export * from "./ModifierGroupList.vue?vue&type=script&lang=js"
import style0 from "./ModifierGroupList.vue?vue&type=style&index=0&id=06e6129b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports